import { render, staticRenderFns } from "./parentPopup.vue?vue&type=template&id=1e4638c6&scoped=true"
import script from "./parentPopup.vue?vue&type=script&lang=js"
export * from "./parentPopup.vue?vue&type=script&lang=js"
import style0 from "./parentPopup.vue?vue&type=style&index=0&id=1e4638c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4638c6",
  null
  
)

export default component.exports